export const related = ['/build-planner', '/abilities', '/trophies'];
export const quickAnswer =
  'Finish the main story, then complete Pope’s Research in The Unknown to obtain the reward that grants an additional combat ability choice.';
export const sourceIds = ['gamesradar-abilities'];

## Why the Sixth Slot Is Missing

The additional combat choice is tied to post-story progression. Selecting one ability from each boss group does not by itself complete this requirement.

## Required Progression

After the story, complete **Pope’s Research** in The Unknown. The published ability guide identifies its reward as a **Resonant Combat Token**, allowing an additional ability from a previous choice group. Check the current in-game wording before spending it.

## Where to Equip the Sixth Ability

Return to the game's combat ability setup after claiming the reward. Choose the extra ability there. The website planner keeps one option per group and does not model this extra unlock.

## Combat Readiness Checklist

- Complete the main story.
- Complete the research quest and claim its reward.
- Unlock the additional combat choice in-game.
- Check the loadout and trophy status rather than treating a saved planner URL as proof of completion.
